<template>
  <div class="form-auth">
    <b-form-group v-if="showInputLocal.login" class="mb-3" label="N° client">
      <b-form-input
        type="number"
        v-model="value.login"
        autocomplete="off"
        required
        v-on:input="warning = false"
        ref="login"
        min="0"
        trim
      >
      </b-form-input>
    </b-form-group>
    <b-form-group v-if="showInputLocal.correspondant" class="mb-3" label="N° correspondant">
      <b-form-input
        type="number"
        v-model="value.correspondant"
        autocomplete="off"
        required
        min="0"
        ref="correspondant"
        trim
      >
      </b-form-input>
    </b-form-group>
    <b-form-group v-if="showInputLocal.password" class="mb-3" label="Mot de passe">
      <b-form-input
        type="password"
        v-model="value.password"
        ref="password"
        required
      >
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'form-auth',
  data () {
    return {
      showInputLocal: {}
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    showInput: {
      type: Object,
      required: false
    }
  },
  mounted: function () {
    const vm = this

    vm.buildShowInput()
  },
  methods: {
    buildShowInput: function () {
      const vm = this

      vm.showInputLocal = Object.assign({
        login: true,
        correspondant: true,
        password: true
      }, vm.showInput)
    }
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/Auth/FormAuth.vue